<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
    ref="baseDelete"
  >
    <p> Você tem certeza que deseja deletar a atividade de operação realizada por <b>{{entry.person.name}}</b>?</p>
  </BaseDelete>
</template>

<script>
import BaseDelete from "@shared_components/base_delete.vue";

export default {
  data () {
    return {
      error: null,
      loading: true,
      formErrors: []
    }
  },
  components: {
    BaseDelete: BaseDelete
  },
  props: {
    entry: Object,
    modelNameSingular: String,
  },
  methods: {
    destroyEntry: function() {
      this.$set(this.entry, "_destroy", true);
      this.$emit("entry-destroyed", this.entry);
      this.$refs.baseDelete.closeDialog();
    },
  }
}
</script>

<style scoped></style>
